import { Flex } from 'antd';
import { ReactNode } from 'react';

import { ArtifactType } from '@/shared/types';
import { Typography } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import { UserRequest } from '@/api/types';

type PossibleArtifactType = keyof NonNullable<UserRequest['artifacts_extend']>;

interface HookProps<T extends PossibleArtifactType> {
  artifactType: T;
  userRequest: UserRequest;
}

interface ArtifactCardContentProps<T extends PossibleArtifactType> {
  extendedArtifact: NonNullable<NonNullable<UserRequest['artifacts_extend']>[T]>[number];
}

interface Strategy<T extends PossibleArtifactType> {
  title: ReactNode;
  ArtifactCardContent: React.FC<ArtifactCardContentProps<T>>;
}

export const useExtendedArtifactStrategy = <T extends PossibleArtifactType>({
  artifactType,
  userRequest,
}: HookProps<T>): Strategy<T> => {
  const strategies = {
    [ArtifactType.BUNDLE]: {
      title: (
        <>
          Файли відповіді
          <Typography color="graphite">На звернення №{userRequest.number_application}</Typography>
        </>
      ),
      ArtifactCardContent: (props) => {
        const { extendedArtifact } = props;

        return (
          <Flex vertical gap={8}>
            <Typography variant="H4">Відповідь</Typography>
            <Typography color="graphite">{formatDate(extendedArtifact.date, '.', false, true)}</Typography>
          </Flex>
        );
      },
    },
  } satisfies Partial<{ [K in PossibleArtifactType]: Strategy<K> }>;

  return strategies[artifactType] as Strategy<T>;
};
